module.exports = __webpack_public_path__ + "static/media/9-7-redcube.478b07bd.png";